import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import Panel from 'utils/panel';
import PredictiveSearchForm from './predictive-search-form';

const PredictiveSearch = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const openPredictiveSearch = () => setIsOpen(true);
    const closePredictiveSearch = () => setIsOpen(false);
    document.addEventListener('openPredictiveSearch', openPredictiveSearch);
    document.addEventListener('closePredictiveSearch', closePredictiveSearch);
    return () => {
      document.removeEventListener(
        'openPredictiveSearch',
        openPredictiveSearch,
      );
      document.removeEventListener(
        'closePredictiveSearch',
        closePredictiveSearch,
      );
    };
  }, []);

  return (
    <Panel
      additionalClasses={`bg-white`}
      align="right"
      context="predictive-search"
      onClose={() => setIsOpen(false)}
      open={isOpen}
    >
      <PredictiveSearchForm />
    </Panel>
  );
};

export default PredictiveSearch;
